export default "__VITE_ASSET__DbSU1trr__"